import { render, staticRenderFns } from "./GradeOverviewTable.vue?vue&type=template&id=b4bb31ce&"
import script from "./GradeOverviewTable.vue?vue&type=script&lang=js&"
export * from "./GradeOverviewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports